import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: min-content;
  padding: 0 15rem;
  height: 100%;
  gap: 35rem;

  ${respondTo.bigPhone`
    width: 100%;
    max-width: 100%;
  `}
`;

export const LogoWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
`;

export const Logo = styled.img`
  max-width: 100%;
  width: 100%;
  height: auto;
  transform: scale(0.8);

  @media (max-height: 760px) {
    height: 225rem;
  }

  ${respondTo.midTablet`
    max-width: 70%;
    transform: scale(1);
  `}

  ${respondTo.bigPhone`
    max-width: 80%;
  `}
`;

export const Label = styled.label`
  font-size: 50rem;
  line-height: 75rem;
  font-weight: 500rem;
  color: ${COLORS.BLACK};
  text-align: center;

  ${respondTo.smallTablet`
    font-size: 40rem;
  `}

  ${respondTo.bigPhone`
    font-size: 30rem;
    line-height: 1.2;
  `}
`;

export const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: flex-end;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50rem;
`;
